export const computeIsMaxChoiceReached = (
    selected: Map<unknown, boolean> | undefined,
    maxChoice: number | undefined,
): boolean => {
    if (!selected || !maxChoice) {
        return false;
    }

    let count = 0;

    selected.forEach((value) => {
        if (value) count += 1;
    });

    return count >= maxChoice;
};
